import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import { createInvoice, fetchInvoiceData, fetchPorts, getSASToBlob } from "../../../api/po";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import Grid from '@mui/material/Grid';
import { formatValueWithCommas } from "../../helper";
import SweetAlert from "react-bootstrap-sweetalert";

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const Invoice = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Invoice'))

    const [poList, setPOList] = useState([]);
    const [portList, setPortList] = useState([]);
    const [selectedPort, setSelectedPort] = useState(null);
    const [payload, setPayload] = useState(null);
    const [isSubmitModalOpen, setSubmitModalOpen] = useState(false)

    const [poProducts, setPOProducts] = useState([]);
    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [approvalrows, setApprovalrows] = useState([]);
    const [allInvoiceRows, setAllInvoiceRows] = useState([]);
    const [selectedPO, setSelectedPO] = useState(null);
    const [selectedPOValue, setSelectedPOValue] = useState("");
    const [selectedVendor, setSelectedVendor] = useState("");
    const [resetData, setResetData] = useState(false)
    const [file, setFile] = useState('');

    const [options, setOptions] = useState({
        invoice_number: '',
        invoice_number_error: '',
        invoice_date: '',
        invoice_date_error: '',
        bl_number: '',
        bl_number_error: '',
        bl_date: '',
        bl_date_error: '',
        conversion_rate: '',
        conversion_rate_error: '',
        v_type: ''
    });
    
    const [invoiceNoSet, setInvoiceNoSet] = useState(null);
    const [blNoSet, setBlNoSet] = useState(null);
    const [isLoading, setIsLoading] = useState(false); // New state variable for loading indicator
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [message, setMessage] = useState('Invoice created successfully')
    

  const navigate = useNavigate();


    useEffect(() => {
        if(options.conversion_rate){
            let rows = [...approvalrows];
            rows.forEach(el => {
                el.amount = Number(el.Unit_price) * Number(el.Quantity) * Number(options.conversion_rate);
                el.amount_auto = (Number(el.unit_price) || 0) * (Number(el.received_qty) || 0) * Number(options.conversion_rate);
            });
            setApprovalrows(rows);
        }
    }, [options]);

    const handleInputChange = (value, input_name, index = null) => {
        if(index == null){
            let prev = {...options};
            prev[input_name] = value;
            setOptions(prev);
        } else {

            let rows = [...approvalrows];
            rows[index][input_name] = value; 

            if(input_name == 'received_qty' || input_name == 'unit_price'){
                rows[index]['amount_auto'] = (Number(rows[index]['received_qty']) || 0) * (Number(rows[index]['unit_price']) || 0) * (Number(options.conversion_rate));
            }


            setApprovalrows(rows);
        }
        
    }

    const handleSubmit = async () => {
        try {
            let hasError = false;
            let newOptions = {...options};

            if(!newOptions.invoice_number){
                newOptions.invoice_number_error = 'Invoice number is required!';
                hasError = true;
            } else if (invoiceNoSet.has(newOptions.invoice_number)){
                newOptions.invoice_number_error = 'Invoice number already exists!';
                hasError = true;
            }

            if(!newOptions.invoice_date){
                newOptions.invoice_date_error = 'Invoice date is required!';
                hasError = true;
            }

            if(!newOptions.bl_number){
                newOptions.bl_number_error = 'Billing number is required!';
                hasError = true;
            } else if(blNoSet.has(newOptions.bl_number)){
                newOptions.bl_number_error = 'Billing number already exists!';
                hasError = true;
            }

            if(!newOptions.bl_date){
                newOptions.bl_date_error = 'Billing date is required!';
                hasError = true;
            }

            if(!newOptions.conversion_rate){
                newOptions.conversion_rate_error = 'Exchange rate is required!';
                hasError = true;
            }

            if(hasError){
                setOptions(newOptions);
                return;
            }


            let data = [...poProducts].find(el => el.PONUMBER == selectedPO.label);
            
            const payload = {erp_po_id:String(data.id), port_id: selectedPort.value, invoice_date: dayjs(options.invoice_date).format('YYYY-MM-DD'), invoice_number:options.invoice_number, conversion_rate: options.conversion_rate, bl_date:dayjs(options.bl_date).format('YYYY-MM-DD'), bl_no: options.bl_number, v_type: data.v_type,
                invoice_items: approvalrows.map(el => ({
                    product_name: el.Product_Name,
                    total_qty: Number(el.Quantity),
                    received_qty: Number(el.received_qty), 
                    unit_price: Number(el.unit_price), 
                    container_no: el.container_no, 
                    item_no: el.Product_No, 
                    item_name: el.Product_Name || 'name-123',
                    erp_po_product_id: el.id,
                    displayed_qty: el.Quantity,
                    displayed_unit_price: el.Unit_price,
                    v_type: el.v_type
            }))}

            payload.invoice_items = payload.invoice_items.filter(el => el.received_qty > 0 && el.unit_price > 0 && el.container_no !== '');

            if(payload.invoice_items.length == 0){
                toast.error("Fill all the required fields!");
                return;
            }

            
            //navigate("/purchase-manager/invoice/add-invoice", { state: {payload} });
            setPayload(payload);
            setSubmitModalOpen(true);

        } catch (error) {
            toast.error("Error in submitting invoice data");
            console.log(error);
        }
    }
    useEffect(()=>{
        if(resetData=== true){
            resetDataFunction()
        }
    }, [resetData])
    const resetDataFunction = ()=>{
        setOptions({
            invoice_number: '',
            invoice_number_error: '',
            invoice_date: '',
            invoice_date_error: '',
            bl_number: '',
            bl_number_error: '',
            bl_date: '',
            bl_date_error: '',
            conversion_rate: 1,
            conversion_rate_error: '',
            v_type: ''
        });
    }
    const handleButtonClick = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const toggleList = () => {
        setShowList(!showList);
    };
    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";

    const columns = [
        {
            field: 'Sl_No', headerName: 'SL No.',
            // width: 100,
            sortable: false,
            resizable: false,
            flex: .5,
        },
        
        {
            field: 'Product_Name',
            headerName: 'Item Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            // width: 160,
            flex: 1,
            sortable: false,
            resizable: false,
            editable: false,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div style={{ cursor: 'pointer' }}>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'Quantity',
            headerName: 'Quantity',
            headerClassName: 'table-header-background',
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 0.5,
            //   width: 160,
        },
        {
            field: 'Unit_price',
            headerName: 'Unit Price',
            sortable: false,
            resizable: false,
            flex: .7,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
        },
        {
            field: 'amount',
            headerName: 'Amount',
            sortable: false,
            resizable: false,
            flex: .7,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
        },
        {
            field: 'received_qty',
            headerName: 'Received QTY',
            headerClassName: 'break-header',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div className="mt-1" style={{ cursor: 'pointer' }}>
                        <TextField type="number" className="invoice_field" aria-label="Demo input" value={params.value} onChange={(e) => {
                                                    if(e.target.value >= 0 && e.target.value < 999999999){
                            
                            handleInputChange(e.target.value, "received_qty", params.row.Sl_No - 1)
                                                    }
                                                }
                            } />
                    </div>
                );
            },
            // width: 160,
        },
        {
            field: 'unit_price',
            headerName: 'Unit Price',
            headerClassName: 'break-header',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                return (
                    <div className="mt-1" style={{ cursor: 'pointer' }}>
                        <TextField type="number" className="invoice_field" aria-label="Demo input" value={params.value} onChange={(e) => {
                                                    if(e.target.value >= 0 && e.target.value < 999999999){
                            
                            handleInputChange(e.target.value, "unit_price", params.row.Sl_No - 1)
                                                    }
                            }} />
                    </div>
                );
            },
            // width: 160,
        },
        {
            field: 'container_no',
            headerName: 'Container No',
            headerClassName: 'break-header',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                return (
                    <div className="mt-1 mb-1" style={{ cursor: 'pointer' }}>
                        <TextField  className="invoice_field" aria-label="Demo input" value={params.value} onChange={(e) => handleInputChange(e.target.value, "container_no", params.row.Sl_No - 1)} />
                    </div>
                );
            },
            // width: 160,
        },
        {
            field: 'amount_auto',
            headerName: 'Amount (Auto)',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            renderCell: (params) => {
                return (
                    <div className="mt-1" style={{ cursor: 'pointer' }}>
                        <TextField type="number" className="invoice_field" aria-label="Demo input" value={params.value} disabled />
                    </div>
                );
            },
            // width: 160,
        },
    ];

    const allInvoiceColumns = [
        {
            field: 'Sl_No', headerName: 'SL No.',
            // width: 100,
            sortable: false,
            resizable: false,
            flex: .5,
        },
        {
            field: 'Invoice_no',
            headerName: 'Invoice No.',
            headerClassName: 'table-header-background',
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 0.5,
            //   width: 160,
        },
        {
            field: 'Product_Name',
            headerName: 'Item Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
            flex: 1,
            sortable: false,
            resizable: false,
            editable: false,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div style={{ cursor: 'pointer' }}>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'recieved_qty',
            headerName: 'Quantity',
            headerClassName: 'table-header-background',
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 0.5,
            //   width: 160,
        },
        {
            field: 'Unit_price',
            headerName: 'Unit Price',
            sortable: false,
            resizable: false,
            flex: .7,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
        },
        {
            field: 'container_no',
            headerName: 'Container no',
            sortable: false,
            resizable: false,
            flex: .7,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            // width: 160,
        },
        {
            field: 'amount',
            headerName: 'Amount',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: .7,
            // width: 160,
        }
    ];

    // const approvalrows = [
    //     { id: 1, Sl_No: 1, item_Name: 'HOBS HB-MARICA', quantity: 2, Unit_price: 20, amount: 160000, received_qty:50,unit_price:20,container_no:"BL0987",amount_auto:8000, },
    //     { id: 2, Sl_No: 2,item_Name: 'HOBS HB-MARICA', quantity: 2, Unit_price: 20, amount: 160000, received_qty:50,unit_price:20,container_no:"BL0987",amount_auto:8000, },
    // ];
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);


    const fetchInvoiceDataFromBackend = async () => {
        try {

          const response = await fetchInvoiceData();
          const portData = await fetchPorts()

          setPOList(response.data.poNumbers);
          setPOProducts(response.data.processedData);
          setInvoiceNoSet(new Set(response.data.invoiceNumbers));
          setBlNoSet(new Set(response.data.blNos))

          const portListArray = portData.data.portList.map(port => ({
            label: port.port_name,
            value: port.id
          }));
          setPortList(portListArray)

        } catch (error) {
          toast.error("Error in fetching invoice data");
          console.log(error);
        }
      };

      const addProductRows = (result) => {
        if (result.length > 0) {
            const formattedProducts = result.map((product, index) => ({
            id: product.id, // Assuming index + 1 as ID
            erp_po_id: product.erp_po_id,
            Sl_No: index + 1, // Serial Number
            Product_No: product.ITEMNO,
            Product_Name: product.item_name,
            Quantity: product.remainingQty,
            Unit_price: product.UNITCOST,
            amount: product.remainingQty * product.UNITCOST * options.conversion_rate,
            received_qty: '',
            unit_price: '',
            container_no: '',
            amount_auto: 0,
            v_type: product.v_type
            }));

            setApprovalrows(formattedProducts);
        }
      }

      const addProductInvoiceRows = (result) => {
        if (result.length > 0) {
            const formattedProducts = result.map((product, index) => ({
            id: product.id, // Assuming index + 1 as ID
            Sl_No: index + 1, // Serial Number
            Invoice_no: product.invoice_no,
            Product_No: product.item_no,
            Product_Name: product.item_name,
            recieved_qty: product.received_qty,
            Unit_price: product.unit_price,
            amount: product.unit_price * product.received_qty * product.conversion_rate,
            container_no: product.container_no,

            }));
            setAllInvoiceRows(formattedProducts);
        }
      }

      useEffect(() => {
        setApprovalrows([]);
        setAllInvoiceRows([]);
        setOptions({
            invoice_number: '',
            invoice_number_error: '',
            invoice_date: '',
            invoice_date_error: '',
            bl_number: '',
            bl_number_error: '',
            bl_date: '',
            bl_date_error: '',
            conversion_rate: '',
            conversion_rate_error: '',
            v_type: ''
        });
        setFile('')
        setSelectedVendor('');
            setSelectedPOValue('');
        setSelectedPort(null);

        if(selectedPO){
            setOptions(prev => ({...prev, conversion_rate: 1}));
            setSelectedVendor(selectedPO.vendor_name);
            setSelectedPOValue(selectedPO.po_amount);
            let data = [...poProducts].find(el => el.PONUMBER == selectedPO.label);
            addProductRows(data?.procurementErpPOProducts);
            addProductInvoiceRows(data.procurementInvoice.map(el => {
                let mappedItems = el.procurementInvoiceProducts.map(item => ({
                    ...item,
                    invoice_no: el.invoice_number,
                    conversion_rate: el.conversion_rate
                }));
                return mappedItems;
            }).flat())

        }
      }, [selectedPO, poProducts]);

      useEffect(() => {
        fetchInvoiceDataFromBackend();
      }, [])
      const handlePortChange = (event, value) => {
        setSelectedPort(value)
        // setErrors(prev => ({ ...prev, po: !value }));

      };

      const submitRequisition = async () => {
        try {
            closeModal(); // Closing the modal when 'No' button is clicked
            setIsLoading(true)

            let data = {...payload};
            data.invoice_items = data.invoice_items.map(el => {
                delete el['product_name'];
                delete el['total_qty'];
                return el;
            })

            if (file) {
                const response =  await getSASToBlob({uploadType:'VENDOR'})
     
                const fetchOptions = {
                    method: 'PUT',
                    body: file,
                    headers: {
                        'x-ms-blob-type': 'BlockBlob',
                        'Content-Type': file.type 
                    },
                }
                 if(response.statusCode===200 && response.data.preSignedUrl){
                    
                     try {
                         const res = await fetch(response.data.preSignedUrl, fetchOptions);
             
                         if (res.ok) {
                            data.blob_name = response.data.blobName
                            data.file_name = file.name
                         }
                     } catch (error) {
                         console.error('Error uploading file:', error);
                         toast.error('Error uploading file')
                         return
                     }
                     
                 }
             }


            const response = await createInvoice(data);
            
            if(response.statusCode == 200){
                setSubmitModalOpen(false);
    
                setMessage(`Invoice was created successfully with Invoice no: ${payload.invoice_number}`)
                setIsOpenSweetAlert(true);
                setPayload(null);
                fetchInvoiceDataFromBackend();

            }
        }
        catch (e){
            console.log(e)
            toast.error('Error in creating Purchase invoice')
        }
        finally {
            setIsLoading(false); // Reset loading state after operation completes
        }
    };

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
        setSelectedPO(null);

        // navigate("/purchase-manager/invoice/invoice");
    };

    const onFileChange = (e) => {
        setFile(e.target.files[0]);
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <div className="mb-2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: "10px", }}>
                            <div>
                                <h4 className="mb-0 requisition_text">Invoice Items</h4>
                            </div>
                            <div className="d-flex align-items-center justify-content-end">
                                <button className="assign_vendor" disabled={!selectedPO} onClick={() => handleSubmit()}>Submit</button>
                            </div>
                        </div>
                        <Card>
                            <CardBody>
                                <div>
                                    <div className='d-flex align-items-center mb-2 gap-2'>
                                        <div>
                                            <p className='mb-0 me-2 requisition_type_text'>Invoice </p></div>
                                        <div>
                                            <Autocomplete
                                                 className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 296 }}
                                                options={poList}
                                                value={selectedPO}
                                                onChange={(e, value) => {
                                                    setSelectedPO(value);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Po"
                                                    />
                                                )}
                                            />

                                        </div>
                                        <div>
                                            <Autocomplete
                                                 className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 296 }}
                                                options={poList}
                                                value={selectedPO}
                                                onChange={(e, value) => {
                                                    setSelectedPO(value);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Vendor"
                                                    />
                                                )}
                                            />

                                        </div>
                                        {/* <div className="d-flex align-items-center gap-3 ms-2">
                                            <div className="d-flex gap-2 align-items-center">
                                                <p className="mb-0" style={{color:'#545B69', fontSize:'15px', fontWeight:'500'}}>Vendor Name :</p>
                                                <p className="mb-0" style={{ fontSize:'14px', fontWeight:'500'}}>{selectedVendor}</p>
                                            </div>
                                            <div style={{borderRight:'1px solid rgb(175 172 172)', height: '25px'}}></div>
                                            <div className="d-flex gap-2 align-items-center">
                                                <p className="mb-0" style={{color:'#545B69', fontSize:'15px', fontWeight:'500'}}>PO Value :</p>
                                                <p className="mb-0" style={{ fontSize:'14px', fontWeight:'500'}}>{selectedPOValue}</p>
                                            </div>
                                        </div> */}
                                      
                                    </div>
                                    <div className='d-flex align-items-center mb-2 gap-2 flex-wrap mt-4'>
                                    <Grid container item xs={12} sm={12} spacing={1}>
                                    <Grid item xs={2}>
                                        <div>
                                          
                                            {/* <Autocomplete
                                                    className="invoice_autofield"
                                                    id={`port`}
                                                    // sx={{ width: 205 }}
                                                    sx={{ width: '100%', }}
                                                    options={portList}
                                                    value={selectedPort}
                                                    onChange={handlePortChange}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Select Port" />
                                                    )}
                                                /> */}
                                                <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Port Name"
                                                variant="outlined"
                                                // value={row.quantity}
                                                value={options.invoice_number}

                                                // disabled={row.productName == ''}
                                                onChange={(event) => handleInputChange(event.target.value, 'invoice_number')}
                                                // sx={{ width: 205 }}
                                                sx={{ width: '100%', }}
                                            />

                                        </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                        <div>
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Invoice Number"
                                                variant="outlined"
                                                // value={row.quantity}
                                                value={options.invoice_number}

                                                // disabled={row.productName == ''}
                                                onChange={(event) => handleInputChange(event.target.value, 'invoice_number')}
                                                // sx={{ width: 205 }}
                                                sx={{ width: '100%', }}
                                            />
                                            {options.invoice_number_error && <span className="error-message" style={{ color: 'red' }}>{options.invoice_number_error}</span>}

                                        </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                        <div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker 
                                                  className='payment_date date_picker_fullwidth'
                                                    label="Invoice Date"
                                            

                                                    value={dayjs(options.invoice_date)}
                                                onChange={(event) => handleInputChange(event, 'invoice_date')}

                                                />
                                            </LocalizationProvider>
                                            {options.invoice_date_error && <span className="error-message" style={{ color: 'red' }}>{options.invoice_date_error}</span>}

                                        </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                        <div>
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="BL Number"
                                                variant="outlined"
                                                // value={row.quantity}
                                                value={options.bl_number}

                                                onChange={(event) => handleInputChange(event.target.value, 'bl_number')}
                                                
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 205 }}
                                                sx={{ width: '100%', }}
                                            />
                                            {options.bl_number_error && <span className="error-message" style={{ color: 'red' }}>{options.bl_number_error}</span>}

                                        </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                        <div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                 className='payment_date date_picker_fullwidth'
                                                    label="BL Date"
                                            

                                                    value={dayjs(options.bl_date)}
                                                    onChange={(event) => handleInputChange(event, 'bl_date')}
                                                />
                                            </LocalizationProvider>
                                            {options.bl_date_error && <span className="error-message" style={{ color: 'red' }}>{options.bl_date_error}</span>}

                                        </div>
                                        </Grid>
                                        <Grid item xs={2}>
                                        <div>
                                            <TextField
                                                className="create_requisition_textfield"
                                                // id={`quantity-${index}`}
                                                label="Conversion Rate"
                                                variant="outlined"
                                                // value={row.quantity}
                                                value={options.bl_number}

                                                onChange={(event) => handleInputChange(event.target.value, 'bl_number')}
                                                
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width: 205 }}
                                                sx={{ width: '100%', }}
                                            />
                                            {options.bl_number_error && <span className="error-message" style={{ color: 'red' }}>{options.bl_number_error}</span>}

                                        </div>
                                        </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <div>
                        <div>
                                <h4 className="mb-0 requisition_text">All Invoices</h4>
                            </div>
                            <Box sx={{ height: "100%", width: '100%', marginBottom: '10px', marginTop: '10px' }}>
                                <DataGrid
                                    autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                            {/* <div className="d-flex align-items-center justify-content-end mb-3 mt-2">
                                <button className="assign_vendor" disabled={!selectedPO} onClick={() => handleSubmit()}>Submit</button>
                            </div> */}
                            
                            {/* <Card>
                        <CardBody className="pe-0 pt-0 ps-0">
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th className="text-center">Item Count</th>
                                            <th className="text-center">Total Quantity</th>
                                            <th className="text-center">Total Unit Price</th>
                                            <th className="text-center">Total Amount</th>

                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td className="text-center">{approvalrows.length}</td>
                                                <td className="text-center">{approvalrows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Quantity;
                                                }, 0)}</td>
                                                <td className="text-center">{approvalrows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Unit_price;
                                                }, 0).toFixed(2)}</td>
                                                <td className="text-center">{approvalrows.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.amount;
                                                }, 0).toFixed(2)}</td>
                                                
                                            </tr>
                                        
                                    </tbody>
                                   
                                </table>
                            </div>
                        </CardBody>
                    </Card>  */}
                        </div>
                        <div>
                            {/* <div>
                                <h4 className="mb-0 requisition_text">All Invoices</h4>
                            </div> */}
                            {/* <Box sx={{ height: '100%', width: '100%', marginBottom: '1.5rem', marginTop: '10px' }}>
                                <DataGrid
                                    autoHeight
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={allInvoiceRows}
                                    columns={allInvoiceColumns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box> */}
                        </div>
                    </div>
                </Container>
            </div>

            <Modal
                isOpen={isSubmitModalOpen}
                onRequestClose={() => setSubmitModalOpen(false)}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do you want to create this Invoice?</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={() => setSubmitModalOpen(false)}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Sl No.</th>
                                            <th>Product</th>

                                            <th>Container</th>
                                            <th>Total Quantity</th>
                                            
                                            <th>Rec. Quantity</th>
                                            <th>Unit Price</th>
                                            <th>Func. Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        {payload?.invoice_items.map((row, index) => (
                                            <tr key={row.value}>
                                                <td>{++index}</td>
                                                <td>{row.product_name}</td>
                                                <td>{row.container_no}</td>
                                                <td>{row.total_qty}</td>
                                                <td>{row.received_qty}</td>
                                                <td>{formatValueWithCommas(row.unit_price)}</td>
                                                <td>{formatValueWithCommas(row.unit_price * row.received_qty * payload.conversion_rate)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.total_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + (currentObject.unit_price * currentObject.received_qty * payload.conversion_rate);
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot>
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" disabled={isLoading} onClick={submitRequisition}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={() => setSubmitModalOpen(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title={message}
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
};

export default Invoice;
